/*Copyright (c) 2023. Honeywell International, Inc. All rights reserved.
This file contains trade secrets of Honeywell International, Inc. 
No part may be reproduced or transmitted in any form by any means or for anypurpose without the express written permission of Honeywell. */

import { Region } from "../../models/OptionsModels/Region";
import { IProps1 } from "./FilterOption";

export function getRegionCheckBoxCount(
  RegionAndCustomerIdMapping: React.MutableRefObject<IProps1[]>,
  option: Region
): React.ReactNode {
  return RegionAndCustomerIdMapping.current.find(
    (d) => d.region === option.regionName
  )?.customerIds?.length
    ? RegionAndCustomerIdMapping.current.find(
        (d) => d.region === option.regionName
      )?.customerIds?.length
    : 0;
}
